// extracted by mini-css-extract-plugin
export default {"noAccessContent":"UserMention-module__noAccessContent--YNg0e","noAccessAvatar":"UserMention-module__noAccessAvatar--ZtvRZ"};